import React, { Component } from 'react';

import BoxValues from './BoxValues';
import BoxCoupon from './BoxCoupon';
import BoxPlan from './BoxPlan';
import ConfirmPurchase from './ConfirmPurchase';
import BoxCreditCoupon from './box_credit_coupon/index';

class PurchaseDescription extends Component {
  render() {
    return (
      (
        <h3 className="title-section" key={1}>
          Resumo da compra:
        </h3>
      ),
      (
        <div className="card-descricao" key={2} style={{ width: '100%', position: 'sticky', top: '0' }}>
          <div className="card-descricao-block">
            <div className="item-1">
              <BoxCoupon />
              <BoxCreditCoupon />
              <BoxValues />
            </div>
            <div className="item-2">
              <BoxPlan />
            </div>
          </div>
          <div className="item-3">
            <ConfirmPurchase />
          </div>
        </div>
      )
    );
  }
}

export default PurchaseDescription;



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/PurchaseDescription.jsx